var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35603",
    "data-name": "Rectangle 35603",
    width: 24,
    height: 24,
    rx: 2.5,
    transform: "translate(-21931 2319)",
    fill: "#6f7070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_245",
    "data-name": "Mask Group 245",
    transform: "translate(21931 -2319)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-trash-5034051",
    d: "M127.511,36.879h-4.385a.626.626,0,1,0,0,1.253h.653l.548,12.61a1.879,1.879,0,0,0,1.877,1.8h8.877a1.879,1.879,0,0,0,1.877-1.8l.548-12.61h.653a.626.626,0,1,0,0-1.253h-4.385v-.626A1.253,1.253,0,0,0,132.523,35h-3.759a1.253,1.253,0,0,0-1.253,1.253Zm.626,4.385v6.891a.626.626,0,1,0,1.253,0V41.264a.626.626,0,1,0-1.253,0Zm3.759,0v6.891a.626.626,0,0,0,1.253,0V41.264a.626.626,0,0,0-1.253,0Zm.626-4.385h-3.759v-.626h3.759Z",
    transform: "translate(-22049.645 2287.23)",
    fill: "#6f7070",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5526d5c13744b5dc46874e39835380d8.svg";
export { ForwardRef as ReactComponent };